import React, { useState,useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import CmtSearch from "@coremat/CmtSearch";
import AddWordDialog from "./AddWordDialog";

import MangeWordsTable from "./ManageWordsTable";
import AddBatchWordDialog from "./AddBatchWordDialog";

import EventsRequests from "services/events";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const ManageWordsContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [openAddWord, setOpenAddWord] = useState(false);
  const [openAddBatchDialog, setOpenAddBatchDialog] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  useEffect(() => {
    dispatch(EventsRequests.getAllAciveWGEvents());
  }, []);


  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddWord(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن کلمه
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddBatchDialog(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن گروهی
            </Button>
          </Box>
        </Box>
        <MangeWordsTable
          searchMode={searchVal.trim().length > 0}
          searchInput={searchVal}
        />
      </CmtCardContent>
      <AddWordDialog
        open={openAddWord}
        handleClose={() => setOpenAddWord(false)}
      />
      <AddBatchWordDialog
        open={openAddBatchDialog}
        handleClose={() => setOpenAddBatchDialog(false)}
      />
    </CmtCard>
  );
};

export default ManageWordsContainer;
